import {memo} from "react";
import {Avatar} from "@chakra-ui/react";
import {getAvatarUrl} from "../mockData/avatars";

export const MockAvatar = memo(({name, ...props}: {name: string} & Omit<Avatar.RootProps, "name">) => (
  <Avatar.Root {...props}>
    <Avatar.Image src={getAvatarUrl(name)} />
    <Avatar.Fallback name={name} />
  </Avatar.Root>
));
